export default __webpack_public_path__ + "static/media/fundamental_loading.e1639027.png";